import React, { useState } from "react";
import axios from "axios";

const ProductForm = () => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [formData, setFormData] = useState({
    main: "",
    pname: "",
    product_type: "",
    image: null,
    min_qty: "",
    price: "",
    size: "",
    type: "",
    side: "",
    corner: "",
    lamination: "",
    cover: "",
    page_layout: "",
    sticker_size: "",
    inner_paper: "",
    pages: "",
  });

  // Handle input change for text fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file input change for image
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataObj = new FormData();
    formDataObj.append("main", formData.main);
    formDataObj.append("pname", formData.pname);
    formDataObj.append("min_qty", formData.min_qty);
    formDataObj.append("price", formData.price);
    formDataObj.append("image", formData.image);
    formDataObj.append("product_type", formData.product_type);

    // Add other fields
    Object.keys(formData).forEach((key) => {
      if (
        key !== "main" &&
        key !== "pname" &&
        key !== "min_qty" &&
        key !== "price" &&
        key !== "image" &&
        formData[key] !== ""
      ) {
        formDataObj.append(key, formData[key]); // Add raw text
      }
    });

    try {
      const response = await axios.post(`${baseURL}/api/admin-products`, formDataObj, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Product added successfully!");
      console.log(response.data);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="container mt-4">
      <h2 className="mb-4">Add Product</h2>

      <div className="mb-3">
        <label className="form-label">Category</label>
        <select
          name="main"
          value={formData.main}
          onChange={handleChange}
          className="form-control"
          required
        >
          <option value="" disabled>
            -- Select Category --
          </option>
          <option value="1">Stationery</option>
          <option value="2">Gifts</option>
          <option value="3">Marketing Collaterals</option>
          <option value="4">Packaging</option>
          <option value="5">Personalise Products</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="form-label">Product Name</label>
        <input
          type="text"
          name="pname"
          value={formData.pname}
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Image</label>
        <input
          type="file"
          name="image"
          className="form-control"
          onChange={handleFileChange}
          required
        />
      </div>


      <div className="mb-3">
        
        <input
          type="checkbox"
          name="product_type"
          value={formData.product_type}
          onChange={handleChange}
          className="form-control"
          
        />
        <label className="form-label">Use as template</label>
      </div>

      <div className="mb-3">
        <label className="form-label">Min Quantity</label>
        <input
          type="text"
          name="min_qty"
          value={formData.min_qty}
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Price</label>
        <input
          type="text"
          name="price"
          value={formData.price}
          onChange={handleChange}
          className="form-control"
          required
        />
      </div>

      {/* Textarea fields for JSON-like data */}
      {[
        "size",
        "type",
        "side",
        "corner",
        "lamination",
        "cover",
        "page_layout",
        "sticker_size",
        "inner_paper",
        "pages",
      ].map((field) => (
        <div key={field} className="mb-3">
          <label className="form-label">
            {field.replace("_", " ").toUpperCase()}
          </label>
          <textarea
            name={field}
            className="form-control"
            value={formData[field]}
            onChange={handleChange}
            placeholder="Enter comma-separated values (e.g., value1, value2)"
          />
        </div>
      ))}

      <button type="submit" className="btn btn-primary">
        Submit
      </button>
    </form>
  );
};

export default ProductForm;
